import { render, staticRenderFns } from "./NotificationsPageHeader.vue?vue&type=template&id=17d52c6c&scoped=true"
import script from "./NotificationsPageHeader.vue?vue&type=script&lang=js"
export * from "./NotificationsPageHeader.vue?vue&type=script&lang=js"
import style0 from "./NotificationsPageHeader.vue?vue&type=style&index=0&id=17d52c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d52c6c",
  null
  
)

export default component.exports